import { NavigationSection } from './NavigationSection.widget'
import { BetSlipShare } from './BetSlipShareButton.widget'

/** Used to register custom widgets to render within the Kambi client */
export function registerKambiCustomWidgets() {
  if (!window.customElements) return

  if (!window.customElements.get('navigation-section')) {
    window.customElements.define('navigation-section', NavigationSection)
  }

  if (!window.customElements.get('kambi-betslip-share-button')) {
    window.customElements.define('kambi-betslip-share-button', BetSlipShare)
  }
}
